import { render } from "./ThorondorPageShell.vue?vue&type=template&id=a4cb9ff6"
import script from "./ThorondorPageShell.vue?vue&type=script&lang=js"
export * from "./ThorondorPageShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__